import { render, staticRenderFns } from "./sentList.vue?vue&type=template&id=5796db98&scoped=true"
import script from "./sentList.vue?vue&type=script&lang=js"
export * from "./sentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796db98",
  null
  
)

export default component.exports